import React from 'react'
import './Header.css'
import MenuIcon from '@mui/icons-material/Menu';
import { Avatar, IconButton } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import AppsIcon from '@mui/icons-material/Apps';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { useDispatch, useSelector} from 'react-redux'; 
import {Logoutfrom, selectuser} from './features/userSlice'
import { auth } from './firebase';

function Header() {
const user = useSelector(selectuser);
const dispatch = useDispatch();
const signout =() =>{
  auth.signOut().then(()=>
  dispatch(Logoutfrom())
  )
 
};

  return (
    <div className='header'>
        <div className='header_left'>
            <IconButton><MenuIcon /></IconButton>
            <img src='https://i.pinimg.com/564x/ae/47/fa/ae47fa9a8fd263aa364018517020552d.jpg' alt=''></img>
        </div>
        <div className='header_center'>
            <SearchIcon/>
            <input type="text" placeholder="Search mail"></input>
            <ArrowDropDownIcon className='header_inputcaret'/>
        </div>
        <div className='header_right'>
           <IconButton> <AppsIcon/> </IconButton>
           <IconButton> <NotificationsIcon/> </IconButton>
           <Avatar className='header_avat' src={user?.photoUrl} onClick={signout}/>
        </div>
    </div>
  )
}

export default Header